import { Box, TextField } from "@mui/material"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { TEXT_AREA_STYLING_PROPS } from "@/constants/forms"

export const LocationNotesForm: FC = () => {
  const { control } = useFormContext()
  return (
    <form>
      <Controller
        name='notes'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Box className='relative'>
            <TextField
              {...field}
              {...TEXT_AREA_STYLING_PROPS}
              placeholder='Add a note...'
              minRows={4}
              error={!!error}
              helperText={error?.message}
            />
          </Box>
        )}
      />
    </form>
  )
}
